export default {
  "brand": "USFansLink",
  "brandSub": "Spreadsheet Resource Hub",
  "nav.home": "Home",
  "nav.guides": "Shopping Guides",
  "nav.guide": "Beginner Guide",
  "nav.review": "USFans Review",
  "nav.shipping": "Shipping Cost",
  "nav.qc": "QC Guide",
  "nav.coupon": "Coupon Guide",
  "nav.warehouse": "Warehouse Guide",
  "nav.legit": "Is USFans Legit?",
  "buyNow": "Buy It Now",
  "exploreSpreadsheet": "Explore USFans Spreadsheet",
  "readGuide": "Read the Beginner Guide",
  "language": "Language",
  "backHome": "Back to Home",
  "mainSite": "Visit Main Website",
  "footer.disclaimer": "USFansLink.fun is an independent informational resource. It is not the official USFans website and does not guarantee sellers, products, prices, shipping services or transaction outcomes. Always verify current information before making a purchase.",
  "footer.rights": "All rights reserved.",
  "footer.independent": "Independent Resource",
  "footer.updated": "Updated Guides",
  "footer.multilingual": "Multilingual Support",
};